import type { MessageDescriptor } from 'react-intl-next';

import { token } from '@atlaskit/tokens';

import { colorNames } from './messages';

export const allHumanReadableColors: Map<string, MessageDescriptor> = new Map<
	string,
	MessageDescriptor
>([
	// background colors
	[token('elevation.surface.overlay').toLowerCase(), colorNames.defaultWhite],
	[token('color.background.accent.blue.subtlest').toLowerCase(), colorNames.lightBlue],
	[token('color.background.accent.purple.subtlest').toLowerCase(), colorNames.lightPurple],
	[token('color.background.accent.magenta.subtlest').toLowerCase(), colorNames.lightMagenta],
	[token('color.background.accent.red.subtlest').toLowerCase(), colorNames.lightRed],
	[token('color.background.accent.orange.subtlest').toLowerCase(), colorNames.lightOrange],
	[token('color.background.accent.yellow.subtlest').toLowerCase(), colorNames.lightYellow],
	[token('color.background.accent.lime.subtlest').toLowerCase(), colorNames.lightLime],
	[token('color.background.accent.green.subtlest').toLowerCase(), colorNames.lightGreen],
	[token('color.background.accent.teal.subtlest').toLowerCase(), colorNames.lightTeal],
	[token('color.background.accent.gray.subtler').toLowerCase(), colorNames.subtleGray],
	[token('color.background.accent.blue.subtler').toLowerCase(), colorNames.subtleBlue],
	[token('color.background.accent.purple.subtler').toLowerCase(), colorNames.subtlePurple],
	[token('color.background.accent.magenta.subtler').toLowerCase(), colorNames.subtleMagenta],
	[token('color.background.accent.red.subtler').toLowerCase(), colorNames.subtleRed],
	[token('color.background.accent.orange.subtler').toLowerCase(), colorNames.subtleOrange],
	[token('color.background.accent.yellow.subtler').toLowerCase(), colorNames.subtleYellow],
	[token('color.background.accent.lime.subtler').toLowerCase(), colorNames.subtleLime],
	[token('color.background.accent.green.subtler').toLowerCase(), colorNames.subtleGreen],
	[token('color.background.accent.teal.subtler').toLowerCase(), colorNames.subtleTeal],
	[token('color.background.accent.gray.subtle').toLowerCase(), colorNames.gray],
	[token('color.background.accent.blue.subtle').toLowerCase(), colorNames.blue],
	[token('color.background.accent.purple.subtle').toLowerCase(), colorNames.purple],
	[token('color.background.accent.magenta.subtle').toLowerCase(), colorNames.magenta],
	[token('color.background.accent.red.subtle').toLowerCase(), colorNames.red],
	[token('color.background.accent.orange.subtle').toLowerCase(), colorNames.orange],
	[token('color.background.accent.yellow.subtle').toLowerCase(), colorNames.yellow],
	[token('color.background.accent.lime.subtle').toLowerCase(), colorNames.lime],
	[token('color.background.accent.green.subtle').toLowerCase(), colorNames.green],
	[token('color.background.accent.teal.subtle').toLowerCase(), colorNames.teal],
	[token('color.text.brand').toLowerCase(), colorNames.defaultBlue],
	[token('color.background.accent.gray.bolder').toLowerCase(), colorNames.boldGray],
	[token('color.background.accent.blue.bolder').toLowerCase(), colorNames.boldBlue],
	[token('color.background.accent.purple.bolder').toLowerCase(), colorNames.boldPurple],
	[token('color.background.accent.magenta.bolder').toLowerCase(), colorNames.boldMagenta],
	[token('color.background.accent.red.bolder').toLowerCase(), colorNames.boldRed],
	[token('color.background.accent.orange.bolder').toLowerCase(), colorNames.boldOrange],
	[token('color.background.accent.yellow.bolder').toLowerCase(), colorNames.boldYellow],
	[token('color.background.accent.lime.bolder').toLowerCase(), colorNames.boldLime],
	[token('color.background.accent.green.bolder').toLowerCase(), colorNames.boldGreen],
	[token('color.background.accent.teal.bolder').toLowerCase(), colorNames.boldTeal],
	// text colors
	[token('color.text').toLowerCase(), colorNames.boldGray],
	[token('color.text.accent.blue.bolder').toLowerCase(), colorNames.boldBlue],
	[token('color.text.accent.purple.bolder').toLowerCase(), colorNames.boldPurple],
	[token('color.text.accent.magenta.bolder').toLowerCase(), colorNames.boldMagenta],
	[token('color.text.accent.red.bolder').toLowerCase(), colorNames.boldRed],
	[token('color.text.accent.orange.bolder').toLowerCase(), colorNames.boldOrange],
	[token('color.text.accent.yellow.bolder').toLowerCase(), colorNames.boldYellow],
	[token('color.text.accent.lime.bolder').toLowerCase(), colorNames.boldLime],
	[token('color.text.accent.green.bolder').toLowerCase(), colorNames.boldGreen],
	[token('color.text.accent.teal.bolder').toLowerCase(), colorNames.boldTeal],
	[token('color.text.subtle').toLowerCase(), colorNames.gray],
	[token('color.text.accent.blue').toLowerCase(), colorNames.blue],
	[token('color.text.accent.purple').toLowerCase(), colorNames.purple],
	[token('color.text.accent.magenta').toLowerCase(), colorNames.magenta],
	[token('color.text.accent.red').toLowerCase(), colorNames.red],
	[token('color.text.accent.orange').toLowerCase(), colorNames.orange],
	[token('color.text.accent.yellow').toLowerCase(), colorNames.yellow],
	[token('color.text.accent.lime').toLowerCase(), colorNames.lime],
	[token('color.text.accent.green').toLowerCase(), colorNames.green],
	[token('color.text.accent.teal').toLowerCase(), colorNames.teal],
	[token('color.text.inverse').toLowerCase(), colorNames.white],
	// border colors
	[token('color.border.accent.blue').toLowerCase(), colorNames.blue],
	[token('color.border.accent.purple').toLowerCase(), colorNames.purple],
	[token('color.border.accent.magenta').toLowerCase(), colorNames.magenta],
	[token('color.border.accent.red').toLowerCase(), colorNames.red],
	[token('color.border.accent.orange').toLowerCase(), colorNames.orange],
	[token('color.border.accent.yellow').toLowerCase(), colorNames.yellow],
	[token('color.border.accent.lime').toLowerCase(), colorNames.lime],
	[token('color.border.accent.green').toLowerCase(), colorNames.green],
	[token('color.border.accent.teal').toLowerCase(), colorNames.teal],
	[token('color.border.inverse').toLowerCase(), colorNames.white],
	[token('color.border.accent.gray').toLowerCase(), colorNames.gray],
]);
